import * as React from 'react';

import { Print, TranslateFunction } from '@own-local/ad-utils/lib/types';
import { getLinkUrl } from '@own-local/ad-utils/lib/url';

export interface PrintContentProps {
  active: boolean;
  print: Print;
  translateString: TranslateFunction;
  locale: string;
  gamTrackingUrl?: string;
};

const PrintContent = (props: PrintContentProps) => {
  const { active, translateString, locale, gamTrackingUrl } = props;
  const { adLink, image } = props.print;

  if (!adLink || !image) {
    return null;
  }

  // TODO: this can be removed onced the backend back-fills all the ads.
  const correctedAdLink = adLink.match(/^\/\/s3/) ? `https:${adLink}` : adLink;
  const sectionTitle = translateString('open_print_version', locale, 'Open print version in new tab');

  return active && (
    <a href={getLinkUrl(correctedAdLink, gamTrackingUrl)}
      target="_blank" title={sectionTitle}>
      <img src={image} />
    </a>
  )
};

export default PrintContent;
